module.exports = __webpack_public_path__ + "fonts/Gotham-Thin.7996873c.otf";